// extracted by mini-css-extract-plugin
module.exports = {"relying__title":"stylea_relying__title__AmdGE","relying":"stylea_relying__203Ns","main":"stylea_main__iXBPf","main__item":"stylea_main__item__XuQsZ"};